import {
    ContextualMenu,
    DefaultButton, Dropdown, getId,
    Icon, IDragOptions, Modal, PrimaryButton, TextField
} from '@fluentui/react';
import { DataUtils } from '../../../common/views/DataUtils';
import {
    defaultButtonStyles, dropdownStyles, primaryButtonStyles
} from '../../../common/views/DefaultStyles';
import { StyleUtils } from '../../../common/views/StyleUtils';
import { Utils } from '../../../common/views/Utils';
import { ShortCustomerModel } from '../../../customers/models/CustomerModel';
import CustomerPicker from '../../../customers/views/searches/CustomerPicker';
import { useNewOrderVM } from '../../viewmodels/NewOrderVM';

type NewOrderProps = {
    isAdmin: boolean;
    onClose: () => void;
}

export default function NewOrderView({ isAdmin, onClose }: NewOrderProps) {
    const vm = useNewOrderVM(isAdmin);
    const isMobile = window.innerWidth <= 500;

    const _titleId: string = getId('title');
    const _subtitleId: string = getId('subText');
    const _dragOptions: IDragOptions = {
        moveMenuItemText: 'Move',
        closeMenuItemText: 'Close',
        menu: ContextualMenu
    };

    const width2 = Utils.getColumnWidth(2);
    const width6 = Utils.getColumnWidth(6);
    const width10 = Utils.getColumnWidth(10);

    const linkInput = () => {
        return <div className="pb-10">
            <TextField
                label="Link"
                value={vm.form.link}
                required
                multiline
                rows={2}
                onChange={(_, v) => vm.setField("link", v || "")} />
        </div>;
    }

    const qtySelectChange = (e: any, v: any) => {
        if (v) {
            const value = parseInt(v.key);
            vm.setField("qty", value);
        }
    }

    const qtyPicker = () => {
        return <div className="pb-10">
            <Dropdown
                label="Qty"
                selectedKey={vm.form.qty}
                onChange={qtySelectChange}
                options={DataUtils.getNumberOptions(false)}
                styles={dropdownStyles} />
        </div>;
    }

    const noteInput = () => {
        return <div className="pb-10">
            <TextField
                label="Note"
                value={vm.form.note}
                multiline
                rows={2}
                onChange={(_, v) => vm.setField("note", v || "")} />
        </div>;
    }

    const onCreate = () => {
        vm.create(onClose);
    }

    const buttons = () => {
        return <div className="ms-Grid-row">
            <div className={width6}>
                <DefaultButton
                    onClick={onClose}
                    styles={defaultButtonStyles}
                >Cancel</DefaultButton>
            </div>
            <div className={width6 + " right"}>
                <PrimaryButton
                    onClick={onCreate}
                    styles={primaryButtonStyles}
                >Submit</PrimaryButton>
            </div>
        </div>;
    }

    const onCustomerSelectChange = (customer?: ShortCustomerModel) => {
        vm.setField("customerId", customer != null ? customer.id : 0);
        vm.setField("customer", customer != null ? customer.displayName : "");
    }

    const modalHeader = () => {
        return <div className="ms-Grid">
            <div className="ms-Grid-row">
                <div className={width10}><b>Request for Quote</b></div>
                <div className={width2 + " right"}>
                    <Icon
                        iconName="ChromeClose"
                        className="pointer"
                        onClick={onClose} />
                </div>
            </div>
        </div>;
    }

    return <div>
        <Modal
            isOpen={true}
            titleAriaId={_titleId}
            subtitleAriaId={_subtitleId}
            onDismiss={onClose}
            styles={StyleUtils.getModalWidthStyles(450)}
            isModeless={false}
        >
            <div className="popup-header">
                {modalHeader()}
            </div>
            <div id={_subtitleId} className={(isMobile ? "mobile-" : "") + "popup-body ph-20 pv-10"}>
                {isAdmin && <>
                    <CustomerPicker onSelect={onCustomerSelectChange} />
                </>}

                {linkInput()}
                {qtyPicker()}
                {noteInput()}

                {!vm.loading && <div className="ms-Grid ph-0 pt-10 pb-10">
                    {buttons()}
                </div>}
            </div>
        </Modal>
    </div>;
}